import {
	AppView,
	Lightbox,
	SofaRange,
	FromStage,
	ShoppingItem,
	ProductCardItem,
	YmalSectionType,
	YmalType,
} from 'sofa-reborn-react';
import { IProduct } from '@inter-ikea-kompis/types';
import {
	ApplicationStateActions,
	APP_INIT,
	SET_APP_VIEW,
	SET_CURRENT_LIGHTBOX,
	SET_SOFA_RANGE,
	INIT_IFRAME_HANDLER,
	UPDATE_IFRAME_HEIGHT,
	RESET_IFRAME_HEIGHT,
	SET_DEFAULT_APPLICATION,
	DONE_SAVE_VPC,
	SUCCESS_ADD_TO_BAG,
	SUCCESS_ADD_TO_BAG_YMAL,
	SWIPE_IN_MODULE_SWIPER,
	SET_LANGUAGE_CHANGED,
	SET_HAS_FIRST_INTERACTION_HAPPENED,
	SET_BROWSER_IS_DETECTED,
	SET_LOADING_MODELS,
	SET_ASSET_FOLDER,
	SHOW_DEBUG,
	SET_USE_INDIVIDUAL_ASSETS,
	SET_HAS_VISIT_SCENE,
	SET_COVER_CHANGED,
	SET_LOADING_COVERS,
	SET_SHOW_FAKE_DATA_FORM,
	SET_FAKE_DATA,
	SET_SHOW_IPEX_GALLERY_BUTTON,
	SET_IS_IN_UPPTACKA_PLATFORM,
	SET_FOOTER_HEIGHT,
	SET_HEADER_HEIGHT,
	SET_FROM_NAVIGATOR,
	SET_PRODUCT_VARIANTS_SHOW_MORE,
	SET_PRODUCT_CARD_TYPE_CLICK,
	SET_IDLE_TIME,
	SET_DISABLE_BULK_FETCH,
	SET_INSIGHTS_INITIATED,
	SET_USE_PERSISTED_CONFIG,
	NO_ARTICLES_IN_PLANNER,
	THUMBNAIL_IMAGE_CHANGED,
	SET_IS_DEEPLINKED,
	SET_TOTAL_PRICE_VOICE,
	STATISTICS_QR_PLANNING_ENABLED,
} from './types';

export function appInitiated(): ApplicationStateActions {
	return {
		type: APP_INIT,
	};
}

export function setAppView(value: AppView): ApplicationStateActions {
	return {
		type: SET_APP_VIEW,
		value,
	};
}

export function setCurrentLightbox(value: Lightbox): ApplicationStateActions {
	return {
		type: SET_CURRENT_LIGHTBOX,
		value,
	};
}

export function setSofaRange(value: SofaRange): ApplicationStateActions {
	return {
		type: SET_SOFA_RANGE,
		value,
	};
}

export function iframeHandlerInitiated(): ApplicationStateActions {
	return {
		type: INIT_IFRAME_HANDLER,
	};
}

export function updateIframeHeight(value: number): ApplicationStateActions {
	return {
		type: UPDATE_IFRAME_HEIGHT,
		value,
	};
}

export function resetIframeHeight(): ApplicationStateActions {
	return {
		type: RESET_IFRAME_HEIGHT,
	};
}

export function setDefaultApplication(value: string): ApplicationStateActions {
	return {
		type: SET_DEFAULT_APPLICATION,
		value,
	};
}

export function successAddToBag(
	value: CustomEvent,
	hasAdditionalCover: boolean
): ApplicationStateActions {
	return {
		type: SUCCESS_ADD_TO_BAG,
		value,
		hasAdditionalCover,
	};
}
export function successAddToBagYmal(value: {
	shoppingItems: ShoppingItem[];
	type: YmalType;
	sectionType: YmalSectionType;
}): ApplicationStateActions {
	return {
		type: SUCCESS_ADD_TO_BAG_YMAL,
		value,
	};
}

export function doneSaveVpc(value: string): ApplicationStateActions {
	return {
		type: DONE_SAVE_VPC,
		value,
	};
}

export function swipeInModuleSwiper(): ApplicationStateActions {
	return {
		type: SWIPE_IN_MODULE_SWIPER,
	};
}

export function setHasFirstInteractionHappened(value: boolean): ApplicationStateActions {
	return {
		type: SET_HAS_FIRST_INTERACTION_HAPPENED,
		value,
	};
}

export function setBrowserIsDetected(value: boolean): ApplicationStateActions {
	return {
		type: SET_BROWSER_IS_DETECTED,
		value,
	};
}

export function setLanguageChanged(value: FromStage | null): ApplicationStateActions {
	return {
		type: SET_LANGUAGE_CHANGED,
		value,
	};
}

export function setCoverChanged(value: Lightbox | null): ApplicationStateActions {
	return {
		type: SET_COVER_CHANGED,
		value,
	};
}

export function setLoadingModels(value: boolean): ApplicationStateActions {
	return {
		type: SET_LOADING_MODELS,
		value,
	};
}

export function setLoadingCovers(value: boolean): ApplicationStateActions {
	return {
		type: SET_LOADING_COVERS,
		value,
	};
}

export function setIsDeeplinked(): ApplicationStateActions {
	return {
		type: SET_IS_DEEPLINKED,
	};
}

export function setAssetFolder(name: string | null): ApplicationStateActions {
	return {
		type: SET_ASSET_FOLDER,
		name,
	};
}

export function showDebug(value: boolean): ApplicationStateActions {
	return {
		type: SHOW_DEBUG,
		value,
	};
}

export function setUseIndividualAssets(value: boolean): ApplicationStateActions {
	return {
		type: SET_USE_INDIVIDUAL_ASSETS,
		value,
	};
}

export function setHasVisitScene(value: boolean): ApplicationStateActions {
	return {
		type: SET_HAS_VISIT_SCENE,
		value,
	};
}

export function setShowFakeDataForm(value: boolean): ApplicationStateActions {
	return {
		type: SET_SHOW_FAKE_DATA_FORM,
		value,
	};
}

export function setFakeData(value: IProduct[] | null): ApplicationStateActions {
	return {
		type: SET_FAKE_DATA,
		value,
	};
}

export function setShowIpexGalleryButton(value: boolean): ApplicationStateActions {
	return {
		type: SET_SHOW_IPEX_GALLERY_BUTTON,
		value,
	};
}

export function setIdleTime(value: number): ApplicationStateActions {
	return {
		type: SET_IDLE_TIME,
		value,
	};
}

export function setIsInUpptackaPlatform(value: boolean): ApplicationStateActions {
	return {
		type: SET_IS_IN_UPPTACKA_PLATFORM,
		value,
	};
}

export function setFooterHeight(value: number): ApplicationStateActions {
	return {
		type: SET_FOOTER_HEIGHT,
		value,
	};
}

export function setHeaderHeight(value: number): ApplicationStateActions {
	return {
		type: SET_HEADER_HEIGHT,
		value,
	};
}

export function setFromNavigator(value: string): ApplicationStateActions {
	return {
		type: SET_FROM_NAVIGATOR,
		value,
	};
}

export function setProductVariantsShowMore(value: boolean): ApplicationStateActions {
	return {
		type: SET_PRODUCT_VARIANTS_SHOW_MORE,
		value,
	};
}

export function setProductCardTypeClick(value: ProductCardItem): ApplicationStateActions {
	return {
		type: SET_PRODUCT_CARD_TYPE_CLICK,
		value,
	};
}

export function setDisableBulkFetch(value: boolean): ApplicationStateActions {
	return {
		type: SET_DISABLE_BULK_FETCH,
		value,
	};
}

export function initiateInsights(value: boolean): ApplicationStateActions {
	return {
		type: SET_INSIGHTS_INITIATED,
		value,
	};
}

export function setUsePersistedConfig(value: boolean): ApplicationStateActions {
	return {
		type: SET_USE_PERSISTED_CONFIG,
		value,
	};
}

export function noArticlesInplanner(): ApplicationStateActions {
	return {
		type: NO_ARTICLES_IN_PLANNER,
	};
}

export function setThumbnailImageChanged(value: {
	imageUrl: string;
	origin: string;
}): ApplicationStateActions {
	return {
		type: THUMBNAIL_IMAGE_CHANGED,
		value,
	};
}

export function setTotalPriceVoice(value: string | null): ApplicationStateActions {
	return {
		type: SET_TOTAL_PRICE_VOICE,
		value,
	};
}

export function statisticsQrPlanningEnabled(): ApplicationStateActions {
	return {
		type: STATISTICS_QR_PLANNING_ENABLED,
	};
}
